export const environment = {
  production: true,
  preview: false,
  siteURL: 'https://www.ahome.com.tw',
  firebase: {
    apiKey: 'AIzaSyDu0BAuu3CyAQwOnUOJ_fDkAC4w9CSw_LQ',
    authDomain: 'orange-house-test-f06fe.firebaseapp.com',
    projectId: 'orange-house-test-f06fe',
    storageBucket: 'orange-house-test-f06fe.appspot.com',
    messagingSenderId: '17194175601',
    appId: '1:17194175601:web:e0e9c6b406c7bdffa31fd0',
    measurementId: 'G-MFY5RK4REV',
  },
  geocodingKey: 'AIzaSyChtFKZtsJD9SddgrHC798277jCPXghbkE',
  fbPageId: '100083525340824',
  fbAppId: '101115609238001',
  awoo: {
    url: 'https://api.awoo.org/nununi',
    id: 2204912200,
    token: 'cfe8206976cd4d9ccd4314c5f4aebbb3a1e6dbe0',
  },
};
